import { CategorizacaoClientePadrao } from './../../../models/ticket-abertura.model';
import { Component, ElementRef, Input, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/core/token/token.service';
import { ChamadosService } from 'src/app/services/chamados.service';
import { TarefaService } from 'src/app/services/tarefa.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { environment } from 'src/environments/environment';
import swal from "sweetalert2";
declare let moment: any;
import { ModalTarefaHorasComponent } from "src/app/components/modais/modal-tarefa-horas/modal-tarefa-horas.component";
import { ModalFinalizarTarefaComponent } from '../modal-finalizar-tarefa/modal-finalizar-tarefa.component';
import { ModalReagendamentoComponent } from '../modal-reagendamento/modal-reagendamento.component';
import { Subscription } from 'rxjs';
import { IntegrationService } from 'src/app/services/integration.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import Editor from "src/assets/ckeditor5-41.3.0/build/ckeditor";
import { StripHtmlPipe } from 'src/app/shared/validators/pipes/stripHtml.pipe';
import { TicketService } from 'src/app/services/ticket.service';
import { ModalAdicionarTemplateComponent } from '../modal-adicionar-template/modal-adicionar-template.component';

@Component({
  selector: 'app-modal-tarefa',
  templateUrl: './modal-tarefa.component.html',
  styleUrls: ['./modal-tarefa.component.scss']
})
export class ModalTarefaComponent implements OnInit, OnDestroy {
  newTaskForm: UntypedFormGroup = new UntypedFormGroup({
    description: new UntypedFormControl("", Validators.required),
  });
  create = true;
  files: any = environment.getUploadConfig().text()
  tarefa;
  hoje: Date = new Date();
  fileSelected = [];
  uploadFileType: any = environment.getUploadConfig().docImg();
  uploadFileSize: any = environment.getUploadConfig().sizeMaxBytes;

  @Input() chamadoData?;
  @Input() info_tarefa?;
  @Input() minha_agenda_tarefa?;
  @Input() hasIntegrationGoogleSchedule?;
  @Input() hasIntegrationOutlookSchedule?;

  listagemTarefas = [];
  isFromChamado = false;
  visualizacao;
  configPaginationTarefas = environment.getPaginationDetalhes();
  configPaginationAssociadas = environment.getPaginationDetalhes();
  tarefasAssociadasTecnico = [];
  paginacaoTarefas;
  paginacaoAssociadas;
  horasExec;
  minutosExec;
  descricao = "";
  descricao_html = "";
  horasTotais: any;
  horasTask;
  selector: string;
  newSubs: Subscription;
  chamado: any;
  listGuests: Array<any> = [];
  local: string = '';
  createEvent: boolean = true;
  videoConf: boolean = false;
  linkMeet: any = `<span>${this.translate.instant('NAO_POSSUI')}</span>`;
  isEventGoogleSchedule: boolean = false;
  linkTeams: any = `<span>${this.translate.instant('NAO_POSSUI')}</span>`;
  isEventOutlookCalendar: boolean = false;
  destinatarios = [];
  public Editor = Editor;
  public editorConfig: any;
  private editorDescricao: any;
  // MIL-29356: tipo de template Tarefa (tipoTemplate.js na API)
  private readonly tipoTemplateTarefa = 7;
  salvando: boolean = false;
  visualizaSelectsLaterais: boolean = true;
  private hasShownAutoPauseNotice = false;

  constructor(
    public modal: NgbActiveModal,
    private toastr: ToastrService,
    public translate: TranslateService,
    private tarefaService: TarefaService,
    private _sanitizer: DomSanitizer,
    private chamadosService: ChamadosService,
    private usuarioService: UsuariosService,
    private tokenService: TokenService,
    private modalService: NgbModal,
    private elemRef: ElementRef,
    private integrationService: IntegrationService,
    private ticketService: TicketService,
    private stripHtmlPipe: StripHtmlPipe
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
    this.tarefa = {
      titulo: '',
      cliente_id: '',
      chamado_id: '',
      tecnico_id: '',
      tipo_tarefa_id: '',
      tempo_tarefa: '',
      data_agendamento: '',
      data_limite: '',
      descricao: '',
      descricao_html: '',
      file: [],
      hangout_link: '',
      teams_link: '',
      is_minha_agenda: false
    };
    this.setInfoTarefa();
    this.setMinhaAgendaTarefa(this.minha_agenda_tarefa);
    this.setChamadoData();

    if (this.info_tarefa || this.minha_agenda_tarefa) {
      this.newSubs = this.ticketService.getAberturaTicketPadrao()
        .subscribe({
          next: (results) => {
            if (results && results.categorizacaoClientePadrao) {
              this.visualizaSelectsLaterais = results.categorizacaoClientePadrao.solicitante_cliente;
            }
          },
          error: (error) => console.error('ngOnInit', error)
        });
    }
  }

  validAuthTecnicoGoogle(tarefa): void {
    let params = {
      userId: tarefa.tecnico_id.id
    }
    this.newSubs = this.integrationService.validAuthTecnicoGoogle(params).subscribe(
      {
        next: (result) => {
          if (result && result.hasOwnProperty('active')) {
            this.hasIntegrationGoogleSchedule = result.active;
          }
          if (!this.hasIntegrationGoogleSchedule) {
            this.validAuthTecnicoOutlook(tarefa);
          }
        },
        error: (error) => console.error('validAuthTecnicoGoogle', error)
      }
    )
  }

  validAuthTecnicoOutlook(tarefa): void {
    let params = {
      userId: tarefa.tecnico_id.id
    }
    this.newSubs = this.integrationService.validAuthTecnicoOutlook(params).subscribe(
      {
        next: (result) => {
          if (result && result.hasOwnProperty('active')) {
            this.hasIntegrationOutlookSchedule = result.active;
          }
        },
        error: (error) => console.error('validAuthTecnicoOutlook', error)
      }
    )
  }

  validTitle(): boolean {
    return this.tarefa.titulo.length < 4;
  }

  private extrairIdChamado(chamadoReferencia: unknown): number | null {
    if (chamadoReferencia == null || chamadoReferencia === '') {
      return null;
    }
    if (typeof chamadoReferencia === 'number') {
      return chamadoReferencia;
    }
    if (typeof chamadoReferencia === 'string' && chamadoReferencia.trim() !== '') {
      const idNumerico = Number(chamadoReferencia);
      return Number.isNaN(idNumerico) ? null : idNumerico;
    }
    if (typeof chamadoReferencia === 'object') {
      const chamadoObjeto = chamadoReferencia as { id?: number | string; id_chamado?: number | string };
      if (chamadoObjeto.id != null && chamadoObjeto.id !== '') {
        return Number(chamadoObjeto.id);
      }
      if (chamadoObjeto.id_chamado != null && chamadoObjeto.id_chamado !== '') {
        return Number(chamadoObjeto.id_chamado);
      }
    }
    return null;
  }

  private obterIdInternoChamado(): number | null {
    const idDoVinculoAtual = this.extrairIdChamado(this.tarefa?.chamado_id);
    if (idDoVinculoAtual != null) {
      return idDoVinculoAtual;
    }
    const dadosChamado = this.chamadoData?.dados;
    if (!dadosChamado) {
      return null;
    }
    return this.extrairIdChamado(dadosChamado.chamado_id)
      ?? this.extrairIdChamado(dadosChamado.id)
      ?? this.extrairIdChamado(dadosChamado.id_chamado);
  }

  private normalizarReferenciaChamado(chamadoReferencia: unknown, idChamado: number): { id: number; text: string } {
    if (typeof chamadoReferencia === 'object' && chamadoReferencia !== null) {
      const chamadoObjeto = chamadoReferencia as { text?: string; assunto?: string };
      const textoChamado = chamadoObjeto.text || chamadoObjeto.assunto;
      if (textoChamado) {
        return { id: idChamado, text: textoChamado };
      }
    }
    const assuntoChamado = this.chamadoData?.chamado?.assunto;
    return { id: idChamado, text: assuntoChamado || `#${idChamado}` };
  }

  setChamadoData(): void {
    if (this.chamadoData) {
      const clienteDados = this.chamadoData.dados.cliente_id;
      if (clienteDados && typeof clienteDados === 'object' && clienteDados.id) {
        this.tarefa.cliente_id = {
          id: clienteDados.id,
          text: clienteDados.text || clienteDados.nome || ''
        };
      } else if (!this.chamadoData.tarefa) {
        this.tarefa.cliente_id = null;
      }

      const idChamadoInterno = this.obterIdInternoChamado();
      if (idChamadoInterno != null) {
        this.tarefa.chamado_id = this.normalizarReferenciaChamado(
          this.chamadoData.dados.chamado_id,
          idChamadoInterno
        );
        this.listaTarefas(this.tarefa.chamado_id);
      }

      this.isFromChamado = true;
      if (this.chamadoData.tarefa) {
        if (this.chamadoData.somenteVisualizar) {
          this.visualizacao = true;
        } else {
          this.visualizacao = false;
        }
        this.create = false;
        this.newSubs = this.tarefaService.getTarefaById(this.chamadoData.tarefa.tarefa_id)
          .subscribe({
            next: (results) => {
              this.listGuests = results.tarefa.convidados ? results.tarefa.convidados.split(';') : [];
              this.tarefa.hangout_link = results.tarefa.hangout_link ? results.tarefa.hangout_link : '';
              this.tarefa.teams_link = results.tarefa.teams_link ? results.tarefa.teams_link : '';
              this.setVideoLink();
              this.isEventGoogleSchedule = results.tarefa.kind ? this.checkKindGoogle(results.tarefa.kind) : false;
              this.isEventOutlookCalendar = results.tarefa.kind ? this.checkKindOutlook(results.tarefa.kind) : false;
              this.local = results.tarefa.local ? results.tarefa.local : '';
              this.tarefa.status_id = results.tarefa.status_id;
              this.tarefa.tarefa_id = results.tarefa.tarefa_id;
              this.tarefa.tecnico_id = { id: results.tarefa.tecnico_id, text: results.tarefa.nome_tecnico };
              this.tarefa.tipo_tarefa_id = { id: results.tarefa.tipo_tarefa_id, text: results.tarefa.tipo_descricao };
              this.tarefa.data_agendamento = (results.tarefa.data_agendamento !== null) ? new Date(results.tarefa.data_agendamento) : null;
              this.tarefa.data_limite = (results.tarefa.data_limite !== null) ? new Date(results.tarefa.data_limite) : null;
              this.tarefa.descricao = results.tarefa.descricao;
              this.tarefa.descricao_html = (results.tarefa.descricao_html !== null) ? results.tarefa.descricao_html : results.tarefa.descricao;
              //this.tarefa.descricao_html = results.tarefa.descricao;
              this.descricao = results.tarefa.descricao;
              this.newTaskForm.patchValue({
                description: (results.tarefa.descricao_html !== null) ? results.tarefa.descricao_html : results.tarefa.descricao
              });
              this.tarefa.data_criacao = new Date(results.tarefa.data_criacao);
              this.tarefa.horarios = results.tarefa.logsHorasTrabalhadas;
              let totalHoras = 0
              this.tarefa.horarios.forEach(h => {
                let teste = moment(h.horas_trabalhadas, 'h:mm').format('HH:mm:ss')
                totalHoras += moment.duration(teste).asSeconds()
              });
              this.tarefa.titulo = results.tarefa.titulo ? results.tarefa.titulo : ''
              this.secondsToHour(totalHoras)
              if (results.tarefa.cliente_id) {
                this.tarefa.cliente_id = {
                  id: results.tarefa.cliente_id,
                  text: results.tarefa.nome_cliente || ''
                };
              }
              if (results.tarefa.chamado) {
                this.tarefa.chamado_id = results.tarefa.chamado;
              }
              if (this.chamadoData.tarefa.tempo_tarefa) {
                this.tarefa.tempo_tarefa = this.chamadoData.tarefa.tempo_tarefa;
                this.horasTask = this.chamadoData.tarefa.tempo_tarefa;
              }

              this.buscarTarefasAgendadas();
              this.checkIntegrations(this.tarefa);

              this.newSubs = this.tarefaService.getAnexosTarefa(this.tarefa.tarefa_id)
                .subscribe({
                  next: (results) => {
                    const res = (results as any)?.result || (results as any)?.results || results;
                    res.lista?.forEach(file => {
                      var typeFile = file.file_name.substring(file.file_name.length - 3);
                      this.fileSelected.push({
                        name: file.file_name,
                        type: typeFile,
                        url: this._sanitizer.sanitize(SecurityContext.URL, file.link_file),
                        id: file.id
                      });
                    })
                  },
                  error: (error) => console.error('setChamadoData', error)
                });
            },
            error: (error) => console.error('setChamadoData', error)
          })
      } else {
        this.visualizacao = false;
      }
    } else {
      this.visualizacao = false;
    }

    if (this.create === true && !this.minha_agenda_tarefa && !this.info_tarefa) {
      var user = this.tokenService.getUsuario();
      this.tarefa.tecnico_id = { id: user.id, text: user.nome };
      this.tarefa.data_agendamento = this.tarefa.data_agendamento === null || this.tarefa.data_agendamento === undefined || this.tarefa.data_agendamento === '' ? new Date() : this.tarefa.data_agendamento;
      this.checkIntegrations(this.tarefa);
    }


    this.setEditorConfig();
  }

  setEditorConfig(): void {
    this.editorConfig = {
      image: {
        resizeUnit: 'px',
        resizeOptions: [
          { name: 'resizeImage:original', label: 'Original', value: null },
          { name: 'resizeImage:100', label: '100px', value: '100' },
          { name: 'resizeImage:200', label: '200px', value: '200' }
        ]
      },
      placeholder: this.translate.instant('INSIRA_TEXTO_IMAGEM')
    };
  }

  onEditorDescricaoReady(editor): void {
    this.editorDescricao = editor;
  }

  openTemplateModal(): void {
    const modalRef = this.modalService.open(
      ModalAdicionarTemplateComponent,
      {
        backdrop: "static",
        windowClass: "modal-custom-milvus",
        keyboard: false,
        size: "medio",
        scrollable: false,
      }
    );

    modalRef.componentInstance.tipoTemplate = this.tipoTemplateTarefa;
    // Macros de ticket só são preenchidas quando a tarefa tem ticket vinculado no momento da aplicação
    modalRef.componentInstance.chamado_id = this.obterIdInternoChamado();
    modalRef.result.then((result) => {
      if (result && result.template) {
        this.inserirTemplateDescricao(result.template);
      }
    }).catch(() => undefined);
  }

  private inserirTemplateDescricao(templateHtml: string): void {
    if (!this.editorDescricao) {
      this.newTaskForm.patchValue({
        description: `${this.editorHtml('description')}${templateHtml}`
      });
      return;
    }

    // Mesmo comportamento do comentário do ticket: insere na posição do cursor, sem apagar o conteúdo atual
    this.editorDescricao.model.change(() => {
      const viewFragment = this.editorDescricao.data.processor.toView(templateHtml);
      const modelFragment = this.editorDescricao.data.toModel(viewFragment);

      this.editorDescricao.model.insertContent(modelFragment, this.editorDescricao.model.document.selection.getFirstPosition());
    });
  }

  private editorHtml(formName: string): string {
    return this.newTaskForm.get(formName)?.value ?? '';
  }

  private editorTexto(formName: string): string {
    return this.stripHtmlPipe.transform(this.editorHtml(formName));
  }

  checkFields(formName: string): boolean {
    const html = this.editorHtml(formName);
    const cleanText = this.editorTexto(formName).replaceAll('\n', '');
    const hasImage = /<img/.test(html);
    return (cleanText.length <= 5 && !hasImage);
  }

  setInfoTarefa(): void {
    if (this.info_tarefa) {
      let tarefa_recebida_id = this.info_tarefa.Id || this.info_tarefa.tarefa_id;
      if (tarefa_recebida_id) {
        this.create = false;
        this.visualizacao = false
        this.isFromChamado = false
        this.newSubs = this.tarefaService.getTarefaById(tarefa_recebida_id)
          .subscribe({
            next: (results) => {
              this.listGuests = results.tarefa.convidados ? results.tarefa.convidados.split(';') : [];
              this.tarefa.hangout_link = results.tarefa.hangout_link ? results.tarefa.hangout_link : '';
              this.setVideoLink();
              this.isEventGoogleSchedule = results.tarefa.kind ? this.checkKindGoogle(results.tarefa.kind) : false;
              this.isEventOutlookCalendar = results.tarefa.kind ? this.checkKindOutlook(results.tarefa.kind) : false;
              this.local = results.tarefa.local ? results.tarefa.local : '';
              this.tarefa.status_id = results.tarefa.status_id;
              this.tarefa.tarefa_id = results.tarefa.tarefa_id;
              this.tarefa.tecnico_id = { id: results.tarefa.tecnico_id, text: results.tarefa.nome_tecnico };
              this.tarefa.tipo_tarefa_id = { id: results.tarefa.tipo_tarefa_id, text: results.tarefa.tipo_descricao };
              this.tarefa.data_agendamento = (this.info_tarefa.StartTime !== null) ? new Date(this.info_tarefa.StartTime) : null;
              this.tarefa.descricao = results.tarefa.descricao;
              this.tarefa.descricao_html = (results.tarefa.descricao_html !== null) ? results.tarefa.descricao_html : results.tarefa.descricao;
              this.newTaskForm.patchValue({
                description: this.tarefa.descricao_html
              });
              this.descricao = results.tarefa.descricao;
              this.descricao_html = (results.tarefa.descricao_html !== null) ? results.tarefa.descricao_html : results.tarefa.descricao;
              this.tarefa.chamado_id = results.tarefa.chamado;
              this.tarefa.cliente_id = { id: results.tarefa.cliente_id, text: results.tarefa.nome_cliente };
              this.tarefa.horarios = results.tarefa.logsHorasTrabalhadas;
              let totalHoras = 0;
              this.tarefa.horarios.forEach(h => {
                let teste = moment(h.horas_trabalhadas, 'h:mm').format('HH:mm:ss')
                totalHoras += moment.duration(teste).asSeconds()
              });
              this.tarefa.titulo = results.tarefa.titulo ? results.tarefa.titulo : this.translate.instant('SEM_TITULO');
              this.secondsToHour(totalHoras)
              if (this.info_tarefa.TempoTarefa) {
                this.tarefa.tempo_tarefa = this.info_tarefa.TempoTarefa;
                this.horasTask = this.info_tarefa.TempoTarefa;
              }
              this.listaTarefas(this.tarefa.chamado_id);
              this.checkIntegrations(this.tarefa);
              this.buscarTarefasAgendadas();

              this.newSubs = this.tarefaService.getAnexosTarefa(this.tarefa.tarefa_id)
                .subscribe({
                  next: (results) => {
                    const res = (results as any)?.result || (results as any)?.results || results;
                    res.lista?.forEach(file => {
                      var typeFile = file.file_name.substring(file.file_name.length - 3);
                      this.fileSelected.push({
                        name: file.file_name,
                        type: typeFile,
                        url: this._sanitizer.sanitize(SecurityContext.URL, file.link_file)
                      });
                    })
                  },
                  error: (error) => console.error('setInfoTarefa', error)
                });
            },
            error: (error) => console.error('setInfoTarefa', error)
          })

      } else {
        this.create = true;
        this.visualizacao = false;
        this.isFromChamado = false;
        if (this.info_tarefa.TempoTarefa) {
          this.tarefa.tempo_tarefa = this.chamadoData.tarefa.tempo_tarefa;
          this.horasTask = this.chamadoData.tarefa.tempo_tarefa;
        }
        this.tarefa.tecnico_id = this.info_tarefa.EmployeeId;
        this.tarefa.data_agendamento = this.info_tarefa.StartTime;

        this.checkIntegrations(this.tarefa);

        this.newSubs = this.usuarioService.getUsuarioById(this.info_tarefa.EmployeeId ? this.info_tarefa.EmployeeId : this.tokenService.getUsuario().id).subscribe(
          {
            next: (result) => {
              this.tarefa.tecnico_id = { id: result.usuario.id, text: result.usuario.nome };
            },
            error: (error) => console.error('setInfoTarefa', error)
          }
        )
      }
    }
  }

  setMinhaAgendaTarefa(minha_agenda_tarefa: any): void {
    if (minha_agenda_tarefa) {
      if (minha_agenda_tarefa.hasOwnProperty('Id')) {
        this.create = false;
        this.visualizacao = false
        this.isFromChamado = false
        this.newSubs = this.tarefaService.getTarefaById(minha_agenda_tarefa.Id)
          .subscribe(
            (results) => {
              this.tarefa.is_minha_agenda = true;
              this.listGuests = results.tarefa.convidados ? results.tarefa.convidados.split(';') : [];
              this.tarefa.hangout_link = results.tarefa.hangout_link ? results.tarefa.hangout_link : '';
              this.setVideoLink();
              this.isEventGoogleSchedule = results.tarefa.kind ? this.checkKindGoogle(results.tarefa.kind) : false;
              this.isEventOutlookCalendar = results.tarefa.kind ? this.checkKindOutlook(results.tarefa.kind) : false;
              this.local = results.tarefa.local ? results.tarefa.local : '';
              this.tarefa.status_id = results.tarefa.status_id;
              this.tarefa.tarefa_id = results.tarefa.tarefa_id;
              this.tarefa.tecnico_id = { id: results.tarefa.tecnico_id, text: results.tarefa.nome_tecnico };
              this.tarefa.tipo_tarefa_id = { id: results.tarefa.tipo_tarefa_id, text: results.tarefa.tipo_descricao };
              this.tarefa.data_agendamento = (minha_agenda_tarefa.StartTime !== null) ? minha_agenda_tarefa.StartTime : null;
              this.tarefa.descricao = results.tarefa.descricao;
              this.tarefa.descricao_html = (results.tarefa.descricao_html !== null) ? results.tarefa.descricao_html : results.tarefa.descricao;
              this.descricao = results.tarefa.descricao;
              this.newTaskForm.patchValue({
                description: (results.tarefa.descricao_html !== null) ? results.tarefa.descricao_html : results.tarefa.descricao
              });
              this.tarefa.chamado_id = results.tarefa.chamado
              this.tarefa.cliente_id = { id: results.tarefa.cliente_id, text: results.tarefa.nome_cliente }
              this.tarefa.horarios = results.tarefa.logsHorasTrabalhadas;
              let totalHoras = 0
              this.tarefa.horarios.forEach(h => {
                let teste = moment(h.horas_trabalhadas, 'h:mm').format('HH:mm:ss')
                totalHoras += moment.duration(teste).asSeconds()
              });
              this.tarefa.titulo = results.tarefa.titulo ? results.tarefa.titulo : ''
              this.secondsToHour(totalHoras);
              if (minha_agenda_tarefa.TempoTarefa) {
                this.tarefa.tempo_tarefa = minha_agenda_tarefa.TempoTarefa;
                this.horasTask = minha_agenda_tarefa.TempoTarefa;
              }
              this.listaTarefas(this.tarefa.chamado_id);
              this.checkIntegrations(this.tarefa);
              this.newSubs = this.tarefaService.getAnexosTarefa(this.tarefa.tarefa_id)
                .subscribe({
                  next: (results) => {
                    const res = (results as any)?.result || (results as any)?.results || results;
                    res.lista?.forEach(file => {
                      var typeFile = file.file_name.substring(file.file_name.length - 3);
                      this.fileSelected.push({
                        name: file.file_name,
                        type: typeFile,
                        url: this._sanitizer.sanitize(SecurityContext.URL, file.link_file)
                      });
                    })
                  },
                  error: (error) => console.error('setMinhaAgendaTarefa', error)
                })
            }, (error) => console.error('setMinhaAgendaTarefa', error)
          )

      } else {
        this.create = true;
        this.visualizacao = false;
        this.isFromChamado = false;
        if (minha_agenda_tarefa.TempoTarefa) {
          this.tarefa.tempo_tarefa = this.chamadoData.tarefa.tempo_tarefa;
          this.horasTask = this.chamadoData.tarefa.tempo_tarefa;
        }
        this.tarefa.data_agendamento = minha_agenda_tarefa.StartTime;
        this.newSubs = this.usuarioService.getUsuarioById(minha_agenda_tarefa.EmployeeId ? minha_agenda_tarefa.EmployeeId : this.tokenService.getUsuario().id).subscribe(
          {
            next: (result) => {
              this.tarefa.tecnico_id = { id: result.usuario.id, text: result.usuario.nome };
              this.checkIntegrations(this.tarefa);
            },
            error: (error) => console.error('setMinhaAgendaTarefa', error)
          }
        )
      }
    }
  }

  monitoraNovaTarefa() {
    var event = new CustomEvent("nova-tarefa-calendario", { "detail": "Example of an event" });
    document.dispatchEvent(event);
  }

  obterChamadoPorId(id) {
    this.newSubs = this.chamadosService.getChamadoById(id).subscribe(
      {
        next: (result) => {
          this.chamado = result.chamado ? result.chamado : {}
        },
        error: (error) => console.error('obterChamadoPorId', error)
      }
    )
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  downloadAnexo(anexo) {
    var fileName = anexo.name;
    var a = document.createElement("a");

    document.body.appendChild(a);

    a.setAttribute('style', 'display: none');
    var fileURL = anexo.url;
    a.href = fileURL;
    a.target = '_blank';
    a.download = fileName;
    document.body.appendChild(a);

    setTimeout(() => {
      a.click();
      window.URL.revokeObjectURL(fileURL);
    })
  }

  verificaHoras(event) {
    this.tarefa.tempo_tarefa = event;
  }

  onPaste(e) {
    return e.clipboardData.getData('Text') !== ''
  }

  triggerFileInput(): void {
    let fileInput = document.getElementById('fileInputTarefa')
    fileInput.click()
  }

  onFileDropped(event) {
    this.changeFile(event)
  }

  changeFile(file: any): void {
    if (file.length > 0 && file.length < 6) {
      for (let _file of file) {
        var mime = require('mime');
        var tipo = mime.getType(_file.name);

        if (tipo !== null) {
          tipo = tipo.split("/");
        } else {
          // evita problemas com ponto final (.) no meio do nome do arquivo
          let fileNameParts = file.name.split(".");
          let lastPart = fileNameParts[fileNameParts.length - 1];
          tipo[1] = lastPart;
        }

        tipo[1] = environment.convertUploadType(tipo[1]);

        var suportado = this.uploadFileType.indexOf(tipo[1]);

        if (_file && _file.size <= this.uploadFileSize && suportado !== -1) {
          var reader = new FileReader();
          reader.readAsDataURL(_file);
          reader.onload = (event) => {
            this.fileSelected.push({
              name: _file.name,
              type: _file.type,
              url: this._sanitizer.sanitize(SecurityContext.URL, event.target.result.toString())
            });
          }

          this.tarefa.file.push(_file);
        }
        else {
          this.toastr.show(this.translate.instant('ARQUIVO_NAO_SUPORTADO_OU_EXCEDEU_LIMITE'), '', environment.toastrConfig('warning'));
        }
      }
    } else if (file.length >= 6) {
      this.toastr.show(this.translate.instant('QNT_ANEXOS_EXCEDIDO'), '', environment.toastrConfig('warning'));
    }
  }

  excluirAnexo(index): void {
    swal
      .fire({
        title: this.translate.instant('DESEJA_DELETAR_ANEXO'),
        icon: "question",
        focusConfirm: true,
        showCancelButton: true,
        confirmButtonText: this.translate.instant("SIM"),
        cancelButtonText: this.translate.instant("NAO")
      })
      .then(result => {
        if (result.isConfirmed) {
          if (this.fileSelected[index].id) {
            this.newSubs = this.tarefaService.deleteAnexoTarefa(this.fileSelected[index].id)
              .subscribe({
                next: (results) => {
                  this.fileSelected.splice(index, 1);
                  this.tarefa.file.splice(index, 1);
                },
                error: (error) => console.error('excluirAnexo', error)
              })
          } else {
            this.fileSelected.splice(index, 1);
            this.tarefa.file.splice(index, 1);
          }
        }
      });
  }

  verificaSeDesativa(): boolean {
    if (this.visualizacao === false) {
      if (this.isFromChamado === true) {
        if ((this.obterIdInternoChamado() != null)
          && (this.tarefa.tecnico_id && this.tarefa.tecnico_id.id)
          && (this.tarefa.data_agendamento && this.tarefa.data_agendamento !== '')
          && (this.tarefa.tempo_tarefa && this.tarefa.tempo_tarefa !== '')
          && !this.checkFields('description')
          && this.tarefa.titulo && this.tarefa.titulo.length > 3) {
          return false
        } else {
          return true;
        }
      } else {
        if ((this.tarefa.tecnico_id && this.tarefa.tecnico_id.id)
          && (this.tarefa.data_agendamento && this.tarefa.data_agendamento !== '')
          && (this.tarefa.tempo_tarefa && this.tarefa.tempo_tarefa !== '')
          && !this.checkFields('description')
          && this.tarefa.titulo && this.tarefa.titulo.length > 3) {
          return false
        } else {
          return true;
        }
      }
    }

    return false;
  }

  getRandomNumber(min, max) {
    return Math.floor(Math.random() * (+max + 1 - +min)) + +min;
  }

  calculateFinalMeet(date): string {
    if (date) {
      return moment(date).add(moment.duration(this.tarefa.tempo_tarefa)).format("YYYY-MM-DD HH:mm:ss");
    }
  }

  setEventGoogleSchedule(formData: FormData, payload: any): void {
    if (formData) {
      formData.append('data_agendamento_google_inicial', moment(this.tarefa.data_agendamento).format("YYYY-MM-DDTHH:mm:ss"));
      formData.append('data_agendamento_google_final', moment(this.calculateFinalMeet(this.tarefa.data_agendamento)).format("YYYY-MM-DDTHH:mm:ss"));
      formData.append('local', this.local);
      formData.append('convidados', JSON.stringify(this.destinatarios));
      formData.append('google_meet', this.videoConf.toString());
    }

    payload['data_agendamento_google_inicial'] = moment(this.tarefa.data_agendamento).format("YYYY-MM-DDTHH:mm:ss");
    payload['data_agendamento_google_final'] = moment(this.calculateFinalMeet(this.tarefa.data_agendamento)).format("YYYY-MM-DDTHH:mm:ss");
    payload['local'] = this.local;
    payload['convidados'] = this.destinatarios;
    payload['google_meet'] = this.videoConf;
    payload['integracao_google'] = "true";
    payload['integracao_outlook'] = "false";
  }

  setEventOutlookCalendar(formData: FormData, payload: any): void {
    if (formData) {
      formData.append('data_agendamento_outlook_inicial', moment(this.tarefa.data_agendamento).format("YYYY-MM-DDTHH:mm:ss"));
      formData.append('data_agendamento_outlook_final', moment(this.calculateFinalMeet(this.tarefa.data_agendamento)).format("YYYY-MM-DDTHH:mm:ss"));
      formData.append('local', this.local);
      formData.append('convidados', JSON.stringify(this.destinatarios));
      formData.append('outlook_teams', this.videoConf.toString());
    }

    payload['data_agendamento_outlook_inicial'] = moment(this.tarefa.data_agendamento).format("YYYY-MM-DDTHH:mm:ss");
    payload['data_agendamento_outlook_final'] = moment(this.calculateFinalMeet(this.tarefa.data_agendamento)).format("YYYY-MM-DDTHH:mm:ss");
    payload['local'] = this.local;
    payload['convidados'] = this.destinatarios;
    payload['outlook_teams'] = this.videoConf;
    payload['integracao_google'] = "false";
    payload['integracao_outlook'] = "true";
  }

  salvarTarefa(): void {
    this.salvando = true;
    if (this.chamadoData) {
      if (this.chamadoData.dados.is_agendar) {
        this.agendarTarefa(this.tarefa);
        return;
      }
    }
    var formData = new FormData();
    this.tarefa.data_agendamento = new Date(this.tarefa.data_agendamento);

    let descriptions = {
      description: this.editorTexto('description'),
      description_html: this.editorHtml('description')
    };

    let payload = {
      tecnico_id: this.tarefa.tecnico_id.id,
      tempo_tarefa: this.tarefa.tempo_tarefa,
      data_agendamento: this.tokenService.convertDateTimezoneStockFormat(moment(this.tarefa.data_agendamento).format("YYYY-MM-DDTHH:mm:ss")),
      descricao: descriptions.description,
      descricao_html: descriptions.description_html,
      titulo: this.tarefa.titulo,
      integracao_google: this.hasIntegrationGoogleSchedule ? (this.hasIntegrationGoogleSchedule && this.createEvent).toString() : "false",
      integracao_outlook: this.hasIntegrationOutlookSchedule ? (this.hasIntegrationOutlookSchedule && this.createEvent).toString() : "false",
      tipo_tarefa_id: this.tarefa.tipo_tarefa_id && this.tarefa.tipo_tarefa_id.id ? this.tarefa.tipo_tarefa_id.id : null
    }

    formData.append('tecnico_id', this.tarefa.tecnico_id.id);
    formData.append('tempo_tarefa', this.tarefa.tempo_tarefa);
    formData.append('data_agendamento', this.tokenService.convertDateTimezoneStockFormat(moment(this.tarefa.data_agendamento).format("YYYY-MM-DDTHH:mm:ss")));
    formData.append('descricao', descriptions.description);
    formData.append('descricao_html', descriptions.description_html);
    formData.append('titulo', this.tarefa.titulo);
    formData.append('integracao_google', this.hasIntegrationGoogleSchedule ? (this.hasIntegrationGoogleSchedule && this.createEvent).toString() : "false");
    formData.append('integracao_outlook', this.hasIntegrationOutlookSchedule ? (this.hasIntegrationOutlookSchedule && this.createEvent).toString() : "false");
    formData.append('tipo_tarefa_id', this.tarefa.tipo_tarefa_id && this.tarefa.tipo_tarefa_id.id ? this.tarefa.tipo_tarefa_id.id : null);


    if (this.tarefa.tarefa_id) {
      formData.append('id', this.tarefa.tarefa_id);
      payload['id'] = this.tarefa.tarefa_id;
    }
    if (this.tarefa.cliente_id && this.tarefa.cliente_id.id) {
      formData.append('cliente_id', this.tarefa.cliente_id.id);
      payload['cliente_id'] = this.tarefa.cliente_id.id;
    } else {
      formData.append('cliente_id', null);
      payload['cliente_id'] = null;
    }
    const idChamadoInterno = this.obterIdInternoChamado();
    if (idChamadoInterno != null) {
      formData.append('chamado_id', String(idChamadoInterno));
      payload['chamado_id'] = idChamadoInterno;
    }

    if (this.tarefa.file && this.tarefa.file.length > 0) {
      this.tarefa.file.forEach(file => {
        formData.append('file', file, file.name);
      });
    }

    if (this.create) {
      if ((this.createEvent)) {
        if (this.hasIntegrationGoogleSchedule) {
          this.setEventGoogleSchedule(formData, payload);
        } else if (this.hasIntegrationOutlookSchedule) {
          this.setEventOutlookCalendar(formData, payload);
        }
      }
      this.newSubs = this.tarefaService.adicionarNovaTarefa(payload)
        .subscribe(result => {
          this.toastr.show(this.translate.instant('SALVO_SUCESSO'), '', environment.toastrConfig('success'));
          if (result) {
            this.monitoraNovaTarefa();
            if (this.tarefa.file && this.tarefa.file.length > 0) {
              var _objTarefa = {
                tarefa: result.tarefa,
                file: this.tarefa.file
              };
              this.newSubs = this.tarefaService.uploadAnexoTarefa(_objTarefa)
                .subscribe({
                  next: () => {
                    this.toastr.show(this.translate.instant('ARQUIVO_ANEXADO'), '', environment.toastrConfig('success'));
                    this.closeModalAfterTaskCreation(result);
                  },
                  error: (error) => console.error('salvarTarefa', error)
                });
            } else {
              this.closeModalAfterTaskCreation(result);
            }
          }

        }, error => {
          this.salvando = false;
        })
    } else {
      if ((this.createEvent)) {
        if (this.hasIntegrationGoogleSchedule) {
          this.setEventGoogleSchedule(formData, payload);
        } else if (this.hasIntegrationOutlookSchedule) {
          this.setEventOutlookCalendar(formData, payload);
        }
      }
      if (this.listGuests.length > 0 && this.destinatarios.length === 0) {
        formData.append('convidados', JSON.stringify(this.listGuests));
        payload['convidados'] = this.listGuests;
      }
      this.newSubs = this.tarefaService.alterarTarefa(payload)
        .subscribe(result => {
          this.toastr.show(this.translate.instant('SALVO_SUCESSO'), '', environment.toastrConfig('success'));
          if (this.tarefa.file && this.tarefa.file.length > 0) {
            var _objTarefa = {
              tarefa: { id: this.tarefa.tarefa_id, cliente_id: this.tarefa.cliente_id ? this.tarefa.cliente_id.id : null },
              file: this.tarefa.file
            };
            this.newSubs = this.tarefaService.uploadAnexoTarefa(_objTarefa)
              .subscribe(results => {
                setTimeout(() => {
                  this.modal.close(result);
                }, 500);
                this.toastr.show(this.translate.instant('ARQUIVO_ANEXADO'), '', environment.toastrConfig('success'));
              }, error => {
                this.salvando = false;
              });
          } else {
            setTimeout(() => {
              this.salvando = false;
              this.modal.close(result);
            }, 500);
          }
        }, error => {
          this.salvando = false;
        })
    }
  }

  private shouldShowAutoPauseAlert(): boolean {
    const hasChamadoLinked = this.obterIdInternoChamado() != null;
    return !this.hasShownAutoPauseNotice && this.create && hasChamadoLinked;
  }

  private showAutoPauseAlert(): Promise<any> {
    return swal.fire({
      icon: "info",
      text: this.translate.instant('ALERTA_NOVA_REGRA_TAREFA'),
      confirmButtonText: this.translate.instant('OK'),
      confirmButtonColor: "#5D69F4",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary"
      }
    });
  }

  private closeModalAfterTaskCreation(result: any, useDelay: boolean = true): void {
    const closeAction = () => this.modal.close(result);
    if (this.shouldShowAutoPauseAlert()) {
      this.hasShownAutoPauseNotice = true;
      this.showAutoPauseAlert().then(() => closeAction());
    } else {
      if (useDelay) {
        setTimeout(() => closeAction(), 500);
      } else {
        closeAction();
      }
    }
  }

  agendarTarefa(agendamento): void {
    const idChamadoInterno = this.obterIdInternoChamado();
    if (idChamadoInterno == null) {
      this.salvando = false;
      return;
    }

    var data_agendamento = this.tokenService.convertDateTimezoneStockFormat(agendamento.data_agendamento);
    const clienteDados = this.chamadoData.dados.cliente_id;
    const idCliente = clienteDados && typeof clienteDados === 'object' ? clienteDados.id : clienteDados;
    var _agendamento = {
      chamado: {
        id_chamado: idChamadoInterno,
        chamado_id: idChamadoInterno,
        cliente_id: idCliente ?? null,
        data_agendamento: data_agendamento,
        descricao_agendamento: this.editorTexto('description'),
        descricao_agendamento_html: this.editorHtml('description'),
        titulo: agendamento.titulo,
        tecnico_id: agendamento.tecnico_id.id,
        tempo_tarefa: this.tarefa.tempo_tarefa,
        integracao_google: this.hasIntegrationGoogleSchedule ? (this.hasIntegrationGoogleSchedule && this.createEvent).toString() : "false",
        integracao_outlook: this.hasIntegrationOutlookSchedule ? (this.hasIntegrationOutlookSchedule && this.createEvent).toString() : "false",
        tipo_tarefa_id: agendamento.tipo_tarefa_id.id
      }
    };

    if (this.createEvent) {
      if (this.hasIntegrationGoogleSchedule) {
        this.setEventGoogleSchedule(null, _agendamento.chamado);
      } else if (this.hasIntegrationOutlookSchedule) {
        this.setEventOutlookCalendar(null, _agendamento.chamado);
      }
    }


    this.newSubs = this.chamadosService.updateAgendamento(_agendamento)
      .subscribe(results => {
        if (agendamento.file.length > 0) {
          agendamento.file.forEach(item => {
            var _objTarefa = {
              tarefa: results.tarefa,
              file: item
            };
            this.newSubs = this.tarefaService.uploadAnexoTarefa(_objTarefa)
              .subscribe({
                next: (results) => { },
                error: (error) => console.error('agendarTarefa', error)
              })
          })
          this.toastr.show(this.translate.instant('SALVO_SUCESSO'), '', environment.toastrConfig('success'));
          this.closeModalAfterTaskCreation('criar', false);
        } else {
          this.toastr.show(this.translate.instant('SALVO_SUCESSO'), '', environment.toastrConfig('success'));
          this.closeModalAfterTaskCreation('criar', false);
        }
      }, error => {
        this.salvando = false;
      })
  }

  listaTarefas(chamado?): void {
    const idChamadoInterno = this.extrairIdChamado(chamado) ?? this.obterIdInternoChamado();
    if (idChamadoInterno != null) {
      var filtro = {
        filtro_body: {
          chamado_id: idChamadoInterno,
          status_id: "__all__"
        }
      };
      this.newSubs = this.tarefaService.listaTarefasChamado(filtro, this.configPaginationAssociadas)
        .subscribe({
          next: (results) => {
            if (results && results.lista) {
              this.listagemTarefas = results.lista;
              this.paginacaoAssociadas = results.meta.paginate;
            }
          },
          error: (error) => console.error('listaTarefas', error)
        })
    } else {
      this.listagemTarefas = [];
    }
  }

  setChamdoId(event): void {
    this.tarefa.chamado_id = event ? event : null;
  }

  setClienteId(event): void {
    this.tarefa.cliente_id = event;
    this.tarefa.chamado_id = null;
    this.listagemTarefas = [];
  }

  finalizarTarefa(tarefa_id): void {
    this.salvando = true;
    if (this.obterIdInternoChamado() != null) {
      const modalRef = this.modalService.open(ModalFinalizarTarefaComponent, {
        scrollable: false,
        windowClass: "modal-custom-milvus",
        size: "medio",
        keyboard: false,
        backdrop: "static",
      });

      var data = this.tarefa;
      modalRef.componentInstance.tarefa = data;
      modalRef.result.then(
        (result) => {
          this.salvando = false;
          if (result) {
            this.modal.close();
          }
        },
        (reason) => { }
      );
    } else {
      this.newSubs = this.tarefaService.finalizarTarefa({ tarefa: { id: this.tarefa.tarefa_id } })
        .subscribe(results => {
          this.toastr.show(this.translate.instant('FINALIZADO_SUCESSO'), '', environment.toastrConfig('success'));
          this.modal.close('finalizou');
        }, error => {
          this.salvando = false;
        })
    }
  }

  abrirModalAgendarTarefa(): void {
    this.salvando = true;
    swal
      .fire({
        title: this.translate.instant('DESEJA_REAGENDAR_TAREFA'),
        text: this.translate.instant('DESCRICAO_AGENDAR_TAREFA'),
        icon: "question",
        focusConfirm: true,
        showCancelButton: true,
        confirmButtonText: this.translate.instant("SIM"),
        cancelButtonText: this.translate.instant("NAO")
      })
      .then(result => {
        if (result.isConfirmed) {
          var _obj = {
            tarefa_id: this.tarefa.tarefa_id,
            tecnico_id: this.tarefa.tecnico_id.id,
            tempo_tarefa: this.tarefa.tempo_tarefa,
            data_agendamento: moment(this.tarefa.data_agendamento).format('YYYY-MM-DD HH:mm'),
            descricao: this.editorTexto('description'),
            descricao_html: this.editorHtml('description'),
            titulo: this.tarefa.titulo,
            integracao_google: this.isEventGoogleSchedule && this.createEvent ? "true" : "false",
            integracao_outlook: this.isEventOutlookCalendar && this.createEvent ? "true" : "false",
            tipo_tarefa_id: this.tarefa.tipo_tarefa_id && this.tarefa.tipo_tarefa_id.id ? this.tarefa.tipo_tarefa_id.id : null,
            cliente_id: this.tarefa.cliente_id,
            chamado_id: this.tarefa.chamado_id,
            local: this.local,
            convidados: this.listGuests,
            google_meet: this.tarefa.hangout_link ? true : false,
            teams_link: this.tarefa.teams_link ? true : false,
            html_link: this.tarefa.html_link ? true : false,
            is_minha_agenda: this.tarefa.is_minha_agenda,
            is_event_google_schedule: this.isEventGoogleSchedule,
            is_event_outlook_calendar: this.isEventOutlookCalendar,
            create_event: this.createEvent,
            has_integration: this.hasIntegrationGoogleSchedule
          };

          const modalRef = this.modalService.open(ModalReagendamentoComponent, {
            scrollable: false,
            windowClass: "modal-custom-milvus",
            size: "medio",
            keyboard: false,
            backdrop: "static",
          });

          var data = _obj;

          modalRef.componentInstance.tarefa = data;
          modalRef.componentInstance.esconde_selects =
            this.chamadoData && this.chamadoData.dados.tipo_solicitante_id !== 1 ? true : false;

          modalRef.result.then(
            (result) => {
              this.salvando = false;
              if (result) {
                this.modal.close();
              }
            }
          );
        } else {
          this.salvando = false;
        }
      });
  }

  buscarTarefasAgendadas(event?): void {

    this.validarDataAgendamento(event);

    if (this.tarefa.tecnico_id !== '' && this.tarefa.tecnico_id !== null) {
      this.configPaginationTarefas.total_registros = 4;
      var _filtro = {
        filtro_body: {
          tecnico_id: this.tarefa.tecnico_id.id,
        }
      };

      if (this.tarefa.data_agendamento !== '' && this.tarefa.data_agendamento !== null) {
        _filtro.filtro_body['data_agendamento'] = this.tokenService.convertDateTimezoneStockFormat(this.tarefa.data_agendamento)
      }

      this.newSubs = this.tarefaService.buscarTarefasAgendadas(_filtro, this.configPaginationTarefas)
        .subscribe({
          next: (results) => {
            if (results && results.lista) {
              this.tarefasAssociadasTecnico = results.lista;
              this.paginacaoTarefas = results.meta.paginate;
            }
          },
          error: (error) => console.error('buscarTarefasAgendadas', error)
        })
    }
  }

  validarDataAgendamento(dataSelecionada: Date): void {
    if (!dataSelecionada) {
      return;
    }

    const hoje = new Date();

    if (dataSelecionada < hoje) {
      this.toastr.show('A data de agendamento não pode ser anterior a hoje.', '', environment.toastrConfig('warning'));
      this.tarefa.data_agendamento = hoje;
    } else {
      this.tarefa.data_agendamento = dataSelecionada;
    }
  }

  paginarListagem(pagina): void {
    this.configPaginationTarefas.pagina = pagina;
    this.buscarTarefasAgendadas();
  }

  paginarAssociadas(pagina): void {
    this.configPaginationAssociadas.pagina = pagina;
    this.listaTarefas(this.tarefa.chamado_id);
  }

  splitName(name): string {
    if (name) {
      var _nome = name.split(' ');
      if (_nome.length > 1) {
        return _nome[0].charAt(0) + _nome[1].charAt(0);
      } else {
        return name.charAt(0);
      }
    }
  }

  deleteTarefa() {
    swal.fire({
      title: this.translate.instant('DESEJA_DELETAR_TAREFA'),
      icon: 'error',
      focusConfirm: true,
      showCancelButton: true,
      confirmButtonText: this.translate.instant("SIM"),
      cancelButtonText: this.translate.instant("NAO"),
    }).then((result) => {
      if (result.isConfirmed) {
        this.newSubs = this.tarefaService.excluirTarefa(this.tarefa.tarefa_id).subscribe(
          {
            next: (result) => {
              this.toastr.show(this.translate.instant('DELETADO_SUCESSO'), '', environment.toastrConfig('success'));
              this.modal.close();
            },
            error: (error) => console.error('deleteTarefa', error)
          }
        )
      }
    });
  }

  verificaRequerido(valor): boolean {
    if (valor !== undefined && valor !== "") {
      return false;
    } else {
      return true;
    }
  }

  showInvalidEmail(): void {
    this.toastr.show(
      this.translate.instant("EMAIL_INVALIDO"),
      "",
      environment.toastrConfig("warning")
    );
  }

  limitaCampo(tipo): void {
    if (tipo === 'horas') {
      if (this.horasExec > 99) {
        this.horasExec = 99;
      }
    } else {
      if (this.minutosExec > 59) {
        this.minutosExec = 59;
      }
    }
  }

  adicionarHoras() {
    const modalRef = this.modalService.open(ModalTarefaHorasComponent, {
      backdrop: "static",
      scrollable: false,
      windowClass: 'modal-custom-milvus',
      keyboard: false,
      size: 'pequeno',
    });

    modalRef.componentInstance.task = this.tarefa
    modalRef.result.then((result) => {
      if (result) {
        let id = this.chamadoData.tarefa.tarefa_id ? this.chamadoData.tarefa.tarefa_id : this.info_tarefa.Id
        this.newSubs = this.tarefaService.getTarefaById(id).subscribe(
          {
            next: (result) => {
              this.tarefa.horarios = result.tarefa.logsHorasTrabalhadas
            },
            error: (error) => console.error('adicionarHoras', error)
          }
        )
      }
    });
  }

  secondsToHour(s) {
    let horas = Math.floor(s / 3600);
    let minutos = Math.floor((s - (horas * 3600)) / 60);
    this.horasTotais = horas + ":" + minutos;
  }

  addGuest(destinatario): void {
    this.destinatarios = [];
    destinatario.forEach((contato) => {
      if (typeof contato === "string") {
        this.destinatarios.push(contato);
      } else {
        this.destinatarios.push(contato[0]);
      }
    });
  }

  setVideoLink(): void {
    if (this.tarefa.hangout_link) {
      this.linkMeet = this._sanitizer.sanitize(SecurityContext.HTML, `<label>${this.translate.instant('LINK_VIDEO_CONFERENCIA')}</label><br><a style="color: #0046FA; text-decoration: underline;font-family: Poppins; font-size: 15px; font-weight: 500; line-height: 21px; letter-spacing: 0em; text-align: left;" href='${this.tarefa.hangout_link}' target='_blink'>${this.tarefa.hangout_link}</a>`);
    } else if (this.tarefa.teams_link) {
      this.linkMeet = this._sanitizer.sanitize(SecurityContext.HTML, `<label>${this.translate.instant('LINK_VIDEO_CONFERENCIA')}</label><br><a style="color: #0046FA; text-decoration: underline;font-family: Poppins; font-size: 15px; font-weight: 500; line-height: 21px; letter-spacing: 0em; text-align: left;" href='${this.tarefa.teams_link}' target='_blink'>${this.tarefa.teams_link}</a>`);
    } else {
      this.linkMeet = this._sanitizer.sanitize(SecurityContext.HTML, `<label>${this.translate.instant('LINK_VIDEO_CONFERENCIA')}</label><br><span style="opacity: 0.7;">${this.translate.instant('NAO_POSSUI')}</span>`);
    }
  }

  checkKindGoogle(kind): boolean {
    return kind.includes('calendar#event');
  }

  checkKindOutlook(kind): boolean {
    return kind.includes('outlook#calendar');
  }

  checkIfHasTitle(tarefaAssociada): string {
    return tarefaAssociada.titulo ? tarefaAssociada.titulo : this.translate.instant('SEM_TITULO');
  }

  checkIntegrations(tarefa): void {
    if (tarefa && tarefa.tecnico_id) {
      this.validAuthTecnicoGoogle(tarefa);
    } else {
      this.hasIntegrationGoogleSchedule = false;
      this.hasIntegrationOutlookSchedule = false;
    }
  }

  checkIfDisableTipoTarefa(): boolean {
    return (!this.create) && !(this.hasIntegrationGoogleSchedule && this.isEventGoogleSchedule) && !(this.hasIntegrationOutlookSchedule && this.isEventOutlookCalendar);
  }

  checkIfDisableCliente(): boolean {
    return (this.chamadoData || !this.create) && !(this.hasIntegrationGoogleSchedule && this.isEventGoogleSchedule) && !(this.hasIntegrationOutlookSchedule && this.isEventOutlookCalendar);
  }

  checkIfDisableRelacionarChamado(): boolean {
    if ((this.hasIntegrationGoogleSchedule && this.isEventGoogleSchedule) || (this.hasIntegrationOutlookSchedule && this.isEventOutlookCalendar)) {
      return !this.tarefa.cliente_id;
    } else {
      return !this.tarefa.cliente_id || this.chamadoData || !this.create;
    }
  }

  verificaVisualizacaoSelectCliente(): boolean {
    if (this.chamadoData) {
      if (this.chamadoData.dados.tipo_solicitante_id === 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return this.visualizaSelectsLaterais;
    }
  }
}
